/* eslint-disable */
import React from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import $ from 'jquery'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class ListDocs extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      docs: [],
      modalDelete: false,
      modalEdit: false,
      errorname: '',
      errorType: '',
      errorActive: '',
      docArr: [],
      printInfo: []
    }
  }

  getDocType = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            docs: response.data.object.result,
            lengthDocs: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    http.get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {}).then((response) => {
      if (response.data.errror == null) {
        this.setState({
          docArr: response.data.object
        })
      } else {
        this.setState({
          docArr: []
        })
      }
    })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    this.getDocType()
  }

  delete = (numRow) => {
    let docsId = this.state.docs[numRow].id
    let docsName = this.state.docs[numRow].name
    sessionStorage.setItem('selectedRow', numRow)
    sessionStorage.setItem('id', docsId)
    sessionStorage.setItem('docsName', docsName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('docsName')
  }
  deleteOk = () => {
    var selectedRow = sessionStorage.getItem('selectedRow')

    let docId = sessionStorage.getItem('id')
    let data = {
      id: docId
    }
    http
      .post(`${WAREHOUSE.WAREHOUSE_TYPE_DELETE_DOCUMENT}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          message.success('سند با موفقیت حذف شد')
          this.state.docs.splice(selectedRow, 1)
          this.setState(this.state.docs)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify(response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  Edit = (numRow) => {
    let docId = this.state.docs[numRow].id
    let docName = this.state.docs[numRow].name
    let isIn = this.state.docs[numRow].in
    let isOut = this.state.docs[numRow].out
    if (isIn && isOut) {
      var pair = 'pair'
    } else {
      var pair = 'not pair'
    }
    // alert(isIn)
    sessionStorage.setItem('docId', docId)
    sessionStorage.setItem('docName', docName)
    sessionStorage.setItem('pair', pair)
    sessionStorage.setItem('isIn', isIn)
    sessionStorage.setItem('isOut', isOut)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }
  EditCancel = () => {
    sessionStorage.removeItem('docId')
    sessionStorage.removeItem('docName')
    sessionStorage.removeItem('isIn')
    sessionStorage.removeItem('isOut')
    sessionStorage.removeItem('pair')
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }

  EditOk() {
    let docId = sessionStorage.getItem('docId')
    let docName = document.getElementById('name').value
    let typePrimary = document.getElementById('typePrimary').value

    let nameError = false
    let editError = false
    let typeError = false

    if (docId == '') {
      nameError = true
      editError = true
      message.error('لطفا نام سند را وارد کنید')

      this.setState({
        errorname: 'نام سند را وارد کنید'
      })
    } else {
      if (!nameError) {
        this.setState({
          errorname: ''
        })
      }
    }
    if (typePrimary == '') {
      editError = true
      typeError = true
      message.error('لطفا نوع سند را وارد کنید')

      this.setState({
        errorType: 'نوع سند را وارد کنید'
      })
    } else {
      if (!typeError) {
        this.setState({
          errorType: ''
        })
      }
    }

    if (!editError) {
      if (typePrimary == 'pair') {
        var data = {
          id: docId,
          name: docName,
          isIn: true,
          isOut: true
        }
      } else {
        var data = {
          id: docId,
          name: docName,
          isIn: typePrimary == 'true',
          isOut: typePrimary == 'false'
        }
      }

      // alert(JSON.stringify(data))
      http.post(`${WAREHOUSE.WAREHOUSE_TYPE_EDIT_DOCUMENT}`, data, {}).then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.getDocType()

          message.success('ویرایش سند با موفقیت انجام شد')
          this.setState({
            modalEdit: !this.state.modalEdit
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            modalEdit: !this.state.modalEdit
          })
        }
      })
    }
  }

  onResultFetched(data) {
    this.setState({
      docs: data
    })
  }

  changeDropDown(data) {
    this.setState({
      docs: data,
      lengthDocs: sessionStorage.getItem('countAll')
    })
  }

  activate = (numRow) => {
    let status = this.state.docs[numRow].enabled
    if (status) {
      let id = this.state.docs[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${WAREHOUSE.WAREHOUSE_TYPE_DISABLE_DOCUMENT}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getDocType()
          } else {
            message.error('عملیات تغییر وضعیت سند موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.docs[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${WAREHOUSE.WAREHOUSE_TYPE_ENABLE_DOCUMENT}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getDocType()
          } else {
            message.error('عملیات تغییر وضعیت سند موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }
  filter() {
    var filterTypeDoc = document.getElementById('filterTypeDoc').value
    var isInStatus = document.getElementById('filterIsIn').value
    var docTypeIsInput
    if (isInStatus == '') {
      docTypeIsInput = 'isIn=&isOut='
    } else if (isInStatus == 1) {
      docTypeIsInput = 'isIn=true&isOut=false'
    } else if (isInStatus == 0) {
      docTypeIsInput = 'isIn=false&isOut=true'
    } else if (isInStatus == 'pair') {
      docTypeIsInput = 'isIn=true&isOut=true'
    }

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', `name=${filterTypeDoc}&${docTypeIsInput}`)
    this.getDocType()
  }

  exportExcel = () => {
    http
      .get(
        `${WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }

            if (excelReport[i]['in'] && !excelReport[i]['out']) {
              excelReport[i]['docType'] = 'وارده'
            } else if (excelReport[i]['in'] && excelReport[i]['out']) {
              excelReport[i]['docType'] = 'وارده صادره'
            } else if (!excelReport[i]['in'] && excelReport[i]['out']) {
              excelReport[i]['docType'] = 'صادره'
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    const docsName = sessionStorage.getItem('docsName')
    var isIn = sessionStorage.getItem('isIn')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let pair = sessionStorage.getItem('pair')

    let excelColumns = [{title: 'نام سند', value: 'name'}, {title: 'نوع سند', value: 'in'}]
    let printCol = ['ردیف', 'نام', 'نوع سند', 'وضعیت']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش لیست نوع سند ها"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((doc, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{doc.name}</td>
                  <td>{doc.in && !doc.out ? 'وارده' : !doc.in && doc.out ? 'صادره' : 'وارده صادره'}</td>
                  <td>{doc.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش لیست نوع سند ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'docType'}
                field={'docType'}
                title={'نوع سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>لیست نوع سند ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="addDocType"
                  url={WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printLink=""
                  printComponent={this.printTable}
                  execelUrl={WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن نوع سند"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام نوع سند:</label>
                  <select className="form-control" id="filterTypeDoc">
                    <option value="">-----</option>
                    {this.state.docArr.map((docs, index) => (
                      <option key={index} value={docs.name}>
                        {docs.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>ماهیت : </label>
                  <select className="form-control" id="filterIsIn">
                    <option value="">---------</option>
                    <option value={1}>وارده</option>
                    <option value={0}>صادره</option>
                    <option value="pair">وارده صادره</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="tableVisibile">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام سند</td>
                    <td>نوع سند</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.docs.map((doc, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{doc.name}</td>
                      <td>{doc.in && !doc.out ? 'وارده' : !doc.in && doc.out ? 'صادره' : 'وارده صادره'}</td>
                      <td>
                        <button onClick={() => this.activate(index)}>
                          {doc.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.Edit(index)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthDocs}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={WAREHOUSE.WAREHOUSE_REPORT_TYPE_DOCUMENT}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف انبار</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف نوع سند {docsName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف نوع سند
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="sm">
            <ModalHeader toggle={this.EditCancel}>ویرایش سند</ModalHeader>
            <ModalBody>
              <form className="modalForm editWareForm">
                <div className="formComponent">
                  <label>عنوان نوع سند : </label>
                  <input
                    className="form-control"
                    type="text"
                    id="name"
                    name="name"
                    ref={(node) => (this.input = node)}
                    onClick={() => this.input.select()}
                    defaultValue={sessionStorage.getItem('docName')}
                  />
                </div>
                <div className="formComponent">
                  <label>نوع سند : </label>
                  <select className="form-control" id="typePrimary" name="typePrimary">
                    <option value="">---------</option>
                    <option value={true} selected={isIn == 'true' ? true : false}>
                      نوع وارده
                    </option>
                    <option value={false} selected={!(isIn == 'true') ? true : false}>
                      نوع صادره
                    </option>
                    <option value="pair" selected={pair == 'pair' ? true : false}>
                      نوع وارده و صادره
                    </option>
                  </select>
                </div>

                <figure>
                  <label className="hiddenLabel">ds </label>
                </figure>
              </form>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk.bind(this)}>
                ویرایش نوع سند
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default ListDocs
